import React from 'react';
import styles from './styles.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

type Props = {
  id: string,
  textFocus?: String,
  textHover?: String,
  textHoverAndFocus?: String,
};

export default class AriaDescribedby extends React.Component<Props, State> {
  render() {
    const { id, textFocus, textHover, textHoverAndFocus } =
      this.props;

    return (
      <div id={id} className={cx([styles.root])}>
        <p className={cx(styles.interactionType, styles.interactionTypeFocus)}>{textFocus}</p>
        <p className={cx(styles.interactionType, styles.interactionTypeHover)}>{textHover}</p>
        <p className={cx(styles.interactionType, styles.interactionTypeHoverAndFocus)}>{textHoverAndFocus}</p>
      </div>
    );
  }
}
